import React, { useState, useContext } from 'react';
import GlobalStateContext from './globalState';

const LanguageSwitcher = () => {
    const [isOpen, setIsOpen] = useState(false);
    const { language } = useContext(GlobalStateContext);

    const languages = [
        { code: 'en', name: 'English' },
        { code: 'es', name: 'Español' },
        { code: 'fr', name: 'Français' },
        { code: 'de', name: 'Deutsch' },
        { code: 'it', name: 'Italiano' },
        { code: 'pt', name: 'Português' },
        { code: 'nl', name: 'Nederlands' },
        { code: 'pl', name: 'Polski' },
        { code: 'ru', name: 'Русский' },
        { code: 'zh', name: '中文' },
        { code: 'ja', name: '日本語' },
        { code: 'ko', name: '한국어' },
        { code: 'ar', name: 'العربية' },
        { code: 'th', name: 'ไทย' },
        { code: 'vi', name: 'Tiếng Việt' },
    ];

    const currentLanguage = languages.find(lang => lang.code === language) || languages[0];

    const handleLanguageChange = (langCode) => {
        const currentUrl = window.location.pathname + window.location.search;
        const newUrl = new URL(currentUrl, window.location.origin);
        newUrl.searchParams.set('lang', langCode);
        return newUrl.toString();
    };

    return (
        <div className="relative inline-block text-left z-10">
            <div>
                <div
                    type="button"
                    className="inline-flex justify-center items-center rounded-md border border-transparent px-3 py-2 text-sm font-medium text-white text-opacity-80"
                    onClick={() => setIsOpen(!isOpen)}
                >
                    <span className="mr-1 font-semibold">{currentLanguage.code.toUpperCase()}</span>
                    <svg 
                        className="h-4 w-4 transition-transform duration-200 ease-in-out" 
                        xmlns="http://www.w3.org/2000/svg" 
                        viewBox="0 0 20 20" 
                        fill="currentColor" 
                        aria-hidden="true"
                        style={{ transform: isOpen ? 'rotate(180deg)' : 'rotate(0)' }}
                    >
                        <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                    </svg>
                </div>
            </div>

            {isOpen && (
                <div className="origin-top-right absolute right-0 mt-2 w-40 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 overflow-y-auto" 
                     style={{ 
                         maxHeight: '300px', 
                         zIndex: 50,
                         top: '100%',
                         right: 0,
                     }}>
                    <div className="py-1" role="menu" aria-orientation="vertical" aria-labelledby="options-menu">
                        {languages.map((lang) => (
                            <a
                                key={lang.code}
                                href={handleLanguageChange(lang.code)}
                                className={`${language === lang.code ? 'bg-zinc-100 text-gray-900' : 'text-gray-700'} block px-4 py-2 text-sm hover:bg-zinc-100 hover:text-gray-900 w-full text-left`}
                                role="menuitem"
                                onClick={() => setIsOpen(false)}
                            >
                                {lang.code.toUpperCase()} - {lang.name}
                            </a>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default LanguageSwitcher;
